import styled from 'styled-components'

export const Container = styled.p`
  padding-bottom: 16px;
`
